'use client';

import { useEffect } from 'react';
import { emailService } from '@/services/emailService';

export default function EmailServiceInitializer() {
  useEffect(() => {
    // Start email queue processor when component mounts
    // Process every 30 seconds
    emailService?.startEmailQueueProcessor(30000);

    // Cleanup on unmount
    return () => {
      emailService?.stopEmailQueueProcessor();
    };
  }, []);

  return null; // This component doesn't render anything
}